export enum ErrorCode {
  Default = -1,
  NotActivated = 555,
}

export enum TempType {
  collectForm = 0,
  sendEmail = 2,
  formAndEmail = 1,
  advanceH5 = 3,
  link = 4,
  redirectEmail = 5,
}

export enum EvaluationMode {
  submit = "s",
  result = "r",
  config = "c",
}
